export default {
  LAYOUT: {
    FOOTER: { TITLE: 'Footer' },
    MENU: {
      HOME: {
        TITLE: 'Home',
        DASHBOARD: 'Dashboard',
      },
      UI_COMPONENTS: {
        TITLE: 'UI Components',
        EXAMPLES: 'Theme test',
        CRUD: 'CRUD',
        TIMELINE: 'Timeline',
        FORM_LAYOUT: 'Form Layout',
        INPUT: 'Input',
        FLOAT_LABEL: 'Float Label',
        INVALID_STATE: 'Invalid State',
        BUTTON: 'Button',
        TABLE: 'Table',
        LIST: 'List',
        TREE: 'Tree',
        PANEL: 'Panel',
        OVERLAY: 'Overlay',
        MEDIA: 'Media',
        MENU: 'Menu',
        MESSAGE: 'Message',
        FILE: 'File',
        CHART: 'Chart',
        MISC: 'Misc',
      },
      UTILITIES: {
        TITLE: 'Utilidades',
        PRIMENG: 'PrimeNG',
        PRIME_BLOCKS: 'PrimeBlocks',
        PRIME_ICONS: 'PrimeIcons',
        PRIME_FLEX: 'PrimeFlex',
        APEX_CHARTS: 'ApexCharts',
      },
      PAGES: {
        TITLE: 'Páginas',
        LANDING: 'Landing',
        ERRORS: {
          TITLE: 'Errores',
          LOGIN: 'Login',
          ERROR: 'Error',
          ACCESS_DENIED: 'Acceso denegado',
          NOT_FOUND: 'Not found',
        },
        EMPTY: 'Empty',
        PAGINATION: 'Paginación',
        LIST: 'Lista',
        TABLE: 'Tabla',
      },
      GET_STARTED: {
        TITLE: 'Get Started',
        DOCUMENTATION: 'Documentación',
        VIEW_SOURCE: 'Ver fuente',
      },
    },
    NAVBAR: {
      PROFILE: 'Perfil de usuari@',
      LANGUAGE: 'Idioma',
      LANGUAGES: {
        EN: 'Inglés',
        ES: 'Español',
      },
      COMPANY: 'Empresa',
      DATA_MANAGEMENT: 'Configura tus datos',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'USER-MANAGEMENT': 'Gestión de usuari@s',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'ENTITY-LOCATION': 'Gestión de sucursales',
      APP_USERS: 'Usuari@s de la app',
      SAAS_TRAINING: 'Nuevos usuarios en SaaS',
      CHANGE_PASSWORD: 'Cambiar contraseña',
      LOGOUT: 'Cerrar sesión',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'USER-ACTION-LOG': 'Historial de acciones',
      CONTACT: 'Contactar con wokap',
      AI_CONNECTOR: 'MCP | Conectar con GPT o Claude',
      TUTORIAL: 'Ayuda | Guías interactivas',
      TUTORIALS: {
        GENERAL: 'Guía interactiva General',
        OFFERS: 'Guía interactiva Ofertas',
        CANDIDATES: 'Guía interactiva Candidat@s',
        OFFERS_DISABLED_TOOLTIP: 'Esta opción se habilitará cuando tengas ofertas',
        CANDIDATES_DISABLED_TOOLTIP: 'Esta opción se habilitará cuando tu oferta tenga candidat@s',
        NO_CANDIDATES_MESSAGE: 'No se encontraron ofertas con candidat@s. La guía se habilitará cuando tengas candidat@s en alguna oferta.',
      },
      MENU: 'Menú',
      TIKTOK: 'TikTok Demo',
    },
    SIDEBAR: { TITLE: 'Sidebar' },
  },
} as const;
